import { cssBundleHref } from "@remix-run/css-bundle";
import tailwindStyleSheetUrl from './styles/tailwind.css';

import { json, type LinksFunction, type LoaderFunctionArgs } from "@remix-run/node";
import type {
  MetaFunction,
  ShouldRevalidateFunction } from
"@remix-run/react";
import {
  Links,
  LiveReload,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useLoaderData } from
"@remix-run/react";
import { AuthenticityTokenProvider } from "remix-utils/csrf/react";
import { HoneypotProvider } from 'remix-utils/honeypot/react';
import { GeneralErrorBoundary } from "./components/error-boundary.tsx";
import { EpicToaster } from "./components/toaster.tsx";
import { csrf } from './utils/csrf.server.ts';
import { getEnv } from "./utils/env.server.ts";
import { honeypot } from "./utils/honeypot.server.ts";
import { combineHeaders, getDomainUrl } from "./utils/misc.tsx";
import { makeTimings } from "./utils/timing.server.ts";
import { getToast } from "./utils/toast.server.ts";

export const links: LinksFunction = () => [
...(cssBundleHref ? [{ rel: "stylesheet", href: cssBundleHref }] : []),
{ rel: 'preload', href: tailwindStyleSheetUrl, as: 'style' },
{ rel: 'stylesheet', href: tailwindStyleSheetUrl }];


export const meta: MetaFunction = () => {
  return [
  { title: "Book on Demand" },
  { name: "description", content: "Welcome to Book on Demand!" }];

};


export async function loader({ request }: LoaderFunctionArgs) {
  const timings = makeTimings('root loader');

  /*const userId = await time(() => getUserId(request), {
  	timings,
  	type: 'getUserId',
  	desc: 'getUserId in root',
  })
  	const user = userId
  	? await time(
  		() =>
  			prisma.userBack.findUniqueOrThrow({
  				select: {
  					id: true,
  					nome: true,
  					cognome: true,
  					username: true,
  					email: true,
  					ruolo: true
  				},
  				where: { id: userId },
  			}),
  		{ timings, type: 'find user', desc: 'find user in root' },
  	)
  	: null
  if (userId && !user) {
  	console.info('something weird happened')
  	// something weird happened... The user is authenticated but we can't find
  	// them in the database. Maybe they were deleted? Let's log them out.
  	await logout({ request, redirectTo: '/BO' })
  }*/

  const { toast, headers: toastHeaders } = await getToast(request);
  //const { confettiId, headers: confettiHeaders } = getConfetti(request)
  const honeyProps = honeypot.getInputProps();
  const [csrfToken, csrfCookieHeader] = await csrf.commitToken();

  return json(
    {
      //user,
      requestInfo: {
        //hints: getHints(request),
        origin: getDomainUrl(request),
        path: new URL(request.url).pathname
        /*userPrefs: {
        	theme: getTheme(request),
        },*/
      },
      ENV: getEnv(),
      toast,
      //confettiId,
      honeyProps,
      csrfToken
    },
    {
      headers: combineHeaders(
        { 'Server-Timing': timings.toString() },
        toastHeaders,
        //confettiHeaders,
        csrfCookieHeader ? { 'set-cookie': csrfCookieHeader } : null
      )
    }
  );
}


function Document({
  children,
  theme = 'light',
  env = {}




}: {children: React.ReactNode;theme?: 'light' | 'dark';env?: Record<string, string>;}) {
  return (
    <html lang="en" className={`${theme} h-full`} data-theme="theme2">
			<head>
				<Meta />
				<meta charSet="utf-8" />
				<meta name="viewport" content="width=device-width,initial-scale=1,maximum-scale=1" />
				<Links />
			</head>
			<body className="bg-background text-foreground">
				{children}
				<script
          dangerouslySetInnerHTML={{
            __html: `window.ENV = ${JSON.stringify(env)}`
          }} />

				<ScrollRestoration />
				<Scripts />
				<LiveReload />
			</body>
		</html>);

}


export default function App() {
  const data = useLoaderData<typeof loader>();
  return (
    <AuthenticityTokenProvider token={data.csrfToken}>
			<HoneypotProvider {...data.honeyProps}>
			<Document env={data.ENV}>
				<Outlet />
				{/*<Confetti id={data.confettiId} />
            <EpicToaster toast={data.toast} />
            <EpicProgress />*/}
  <EpicToaster toast={data.toast} />
			</Document>
			</HoneypotProvider>
		</AuthenticityTokenProvider>);

}


export function ErrorBoundary() {
  // the nonce doesn't rely on the loader so we can access that

  // NOTE: you cannot use useLoaderData in an ErrorBoundary because the loader
  // likely failed to run so we have to do the best we can.
  // We could probably do better than this (it's possible the loader did run).
  // This would require a change in Remix.

  // Just make sure your root route never errors out and you'll always be able
  // to give the user a better UX.

  return (
    <Document>
			<GeneralErrorBoundary />
		</Document>);

}


export const shouldRevalidate: ShouldRevalidateFunction = ({
  formAction,
  formMethod
}) => {
  return Boolean(formMethod === 'POST');
};